import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const OccupancyRateCardContainer = styled.div`
  background: linear-gradient(
    310deg,
    rgba(254, 225, 64, 1) 0%,
    rgba(255, 3, 134, 1) 100%
  );
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  width: 100%;
  min-height: 284px;
  display: flex;
  border-radius: 20px;
  padding: 25px 8px;
  justify-content: center;
`

export const NoOccupancyLabel = styled.p`
  text-align: center;
  margin: 4em 10px;
  font-weight: 700;
  color: #fff;
`

export const FailedAttemptMessage = styled.p`
  text-align: center;
  margin: 4em 10px;
  font-weight: 700;
  color: #fff;
`

export const PercentageContainer = styled.div<{ width: number }>`
  display: flex;
  width: 3.5em;
  align-items: center; /* Center the content vertically */
`

export const PercentageLabel = styled.p<{ width: number }>`
  color: #fff;
  font-size: ${({ width }) => (width < 680 ? '1.2em' : '2em')};
  margin: ${({ width }) =>
    width < 680 ? '5.5em 0 5.5em 0' : '2.5em 0 2.5em 0'};
  line-height: 1;
  text-align: center;
`

export const LineContainer = styled.div<{ width: number }>`
  width: ${({ width }) => (width < 1350 ? '55%' : width < 750 ? '35%' : '35%')};
  display: flex;
  flex-grow: 1;
`
